<h2>{{ page.title }}</h2>
<div [innerHtml]="page.content"></div>

